module.exports = ol.layer.Image;